import { mascaraCpfCnpj, mascaraPlaca, mascaraTelefone } from '@/nucleo/formato/documentos';
import { CopyableText } from '@/ui/CopyableText';

/**
 * As variantes de `CopyableText` que as listagens usam.
 *
 * Todas seguem a MESMA regra, e ela e a razao destes invólucros existirem: o que
 * aparece e mascarado, o que vai para a area de transferencia e cru. Quem copia um
 * CPF da tabela esta indo colar em outro sistema — normalmente o SGTP ou uma
 * planilha —, e nenhum deles aceita `123.456.789-09`.
 *
 * Repetir `<CopyableText value={cru} display={mascara(cru)} label="…"/>` em cinco
 * telas convidaria ao erro de esquecer o `display` numa delas (CPF ilegivel) ou de
 * mascarar o `value` (copia inutil). Duas repeticoes ja pedem extracao
 * (CLAUDE.md, "Regras de interface", item 1).
 */

interface ValorProps {
  value: string | null | undefined;
  className?: string;
}

/** CPF ou CNPJ, decidido pelo numero de digitos. */
export function CopyableCpfCnpj({ value, className }: ValorProps) {
  const digitos = value ?? '';
  return (
    <CopyableText
      value={digitos || null}
      display={mascaraCpfCnpj(digitos)}
      label={digitos.replace(/\D/g, '').length > 11 ? 'Copiar CNPJ' : 'Copiar CPF'}
      className={className}
    />
  );
}

export function CopyableTelefone({ value, className }: ValorProps) {
  return (
    <CopyableText
      value={value || null}
      display={mascaraTelefone(value)}
      label="Copiar telefone"
      className={className}
    />
  );
}

export function CopyablePlaca({ value, className }: ValorProps) {
  return (
    <CopyableText
      value={value || null}
      display={mascaraPlaca(value)}
      label="Copiar placa"
      className={className}
    />
  );
}

/**
 * E-mail nao ganha mascara — ganha corte. Endereco institucional longo
 * (`coordenacao.transporte.escolar@sme.prefeitura.sp.gov.br`) estouraria a coluna e
 * empurraria a tabela para rolagem horizontal, proibida a partir de 375 px
 * (CLAUDE.md, "Regras de interface", item 4).
 */
export function CopyableEmail({ value, className }: ValorProps) {
  return (
    <CopyableText
      value={value || null}
      label="Copiar e-mail"
      maxWidth="max-w-[200px]"
      className={className}
    />
  );
}
